import React, { useState } from 'react';
import AccordianArrow from '../../../styles/staticAssets/images/Accordian_Arrow.png';
import AccordianUpArrow from '../../../styles/staticAssets/images/Accordian_Up_Arrow.png';
import AccordianDownDark from '../../../styles/staticAssets/images/AccordianDownDark.png';
import AccordianUpDark from '../../../styles/staticAssets/images/AccordianUpDark.png';
import ORDER_HISTORY from '../Constants/Constants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { getFormatFromUnix, formatDateTime, getUnixTimeInSeconds, getTimeString } from 'common/utilities/dayJsUtils';
import { getValueOrDefaultObject } from 'common/utilities/utils';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';

const OrderDetail = props => {
  const {
    onClickHandler,
    isDarkMode = false,
    dataTestId,
    cardInfo = {},
    title,
    occassionTime,
    onEditOccasionName,
    itemId,
    itemName,
    favouriteOrders = [],
    tenantData = {},
  } = props;
  const { ScheduledIcon, Reload } = IMAGE_PATH;
  const { AT, REFUND_INIT, SCHEDULE, REFUND_INIT_TEXT, EDIT_ITEM_TEXT, TODAY_AT, CANCELLED, DELIVERED, PICK_UP } =
    ORDER_HISTORY;

  const {
    id = '',
    fulfillmentDateTime: orderedOn = '',
    service = '',
    status = '',
    fulfillmentDateTime = '',
  } = getValueOrDefaultObject(cardInfo);

  const { pastOrderDateformat = '', pastOrderTimeFormat = '' } = tenantData;
  let favObject = {};
  favObject = (favouriteOrders.length > 0 && favouriteOrders.find(el => el.id === id)) || {};
  const orderName =
    Object.keys(favObject).length > 0
      ? favObject.name
      : `${(service === 'pickup' && PICK_UP) || service} ${translateWithI18Next('order')}`;
  const DateOfOrder = getFormatFromUnix(orderedOn, pastOrderDateformat);
  const scheduledDate = getFormatFromUnix(fulfillmentDateTime, pastOrderDateformat);
  const orderOnDate = `${getFormatFromUnix(orderedOn, pastOrderDateformat)}  ${translateWithI18Next(AT)}`;
  const todayDate = formatDateTime(new Date(), pastOrderDateformat);
  let scheduleText = `${scheduledDate} ${translateWithI18Next(AT)} `;
  const Time = formatDateTime(getUnixTimeInSeconds(orderedOn), pastOrderTimeFormat);
  const TimeDiff = getTimeString(fulfillmentDateTime);

  if (scheduledDate === todayDate) {
    scheduleText = translateWithI18Next(SCHEDULE) + ' for ' + translateWithI18Next(TODAY_AT);
  }

  const [showContent, setShowContent] = useState(false);
  const clickHander = e => {
    setShowContent(!showContent);
    onClickHandler && !showContent && onClickHandler(e, id);
  };

  const isDeliveryCancelledorDelivered = statusData => {
    return statusData !== CANCELLED && statusData !== DELIVERED;
  };

  const checkDate = TimeDiff && (DateOfOrder === todayDate || scheduledDate === todayDate);
  return (
    <div className={`global-accordian-container ${showContent ? 'account-accordian-open' : ''}`}>
      <div className='global-accordian-header-container'>
        <span className='global-accordian-header'>
          {status === REFUND_INIT && !title && (
            <div className='order-accordian-heading-section'>
              <img src={Reload} className='account-icon' alt='Account Icon' />
              <span className='order-status'>{translateWithI18Next(REFUND_INIT_TEXT)}</span>
            </div>
          )}
          {checkDate && isDeliveryCancelledorDelivered(status) ? (
            <div className='order-accordian-heading-section'>
              <img src={ScheduledIcon} className='account-icon' alt='Account Icon' />
              <span className='order-status'>{translateWithI18Next(SCHEDULE)}</span>
            </div>
          ) : null}
          {!title ? (
            <span className='order-accordian-heading'>{orderName}</span>
          ) : (
            <React.Fragment>
              <span className='order-accordian-heading'>{title}</span>
              <span className='edit-occasion-link' onClick={() => onEditOccasionName(itemId, itemName)}>
                {translateWithI18Next(EDIT_ITEM_TEXT)}
              </span>
            </React.Fragment>
          )}
        </span>
        <div className='global-accordian-right'>
          {occassionTime ? (
            <span className='order-time'>{occassionTime}</span>
          ) : (
            <span className='order-time'>{(checkDate && scheduleText + Time) || orderOnDate + ' ' + Time}</span>
          )}
          {isDarkMode ? (
            <img
              src={(showContent && AccordianUpDark) || AccordianDownDark}
              onClick={clickHander}
              className='global-accordian-arrow'
              data-testid='acordian-handle-dark'
              alt='Accordian Handle'
            />
          ) : (
            <img
              src={(showContent && AccordianUpArrow) || AccordianArrow}
              onClick={clickHander}
              className='global-accordian-arrow'
              data-testid={dataTestId}
              alt='Global Accordian'
            />
          )}
        </div>
      </div>
      {showContent && <div className='global-accordian-content'>{props.children}</div>}
    </div>
  );
};

export default OrderDetail;
